import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
// ---Change Password------------------------------
const changePasswordFormSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .required("Password is mandatory")
    .min(3, "Password must be at 3 char long"),
  newPassword: Yup.string()
    .required("New Password is mandatory")
    .min(3, "Password must be at 3 char long"),
  reEnterNewPassword: Yup.string()
    .required("Password is mandatory")
    .oneOf([Yup.ref("newPassword")], "Passwords does not match"),
});
export const changePasswordFormOptions = {
  resolver: yupResolver(changePasswordFormSchema),
};
// ---Register------------------------------
const registerFormSchema = Yup.object().shape({
  username: Yup.string()
    .required("Password is mandatory")
    .min(3, "Password must be at 3 char long"),
  password: Yup.string()
    .required("New Password is mandatory")
    .min(3, "Password must be at 3 char long"),
  email: Yup.string()
    .required("Password is mandatory")
    .oneOf([Yup.ref("newPassword")], "Passwords does not match"),
});
export const registerFormOptions = {
  resolver: yupResolver(registerFormSchema),
};
// ---AddAccount------------------------------
const addAccountFormSchema = Yup.object().shape({
  account: Yup.string().required("Account is mandatory"),
  key: Yup.string()
    .required("Key is mandatory")
    .matches(/^\d{4}$/, "TIN must be exactly 4 digits"),
});
export const addAccountFormOptions = {
  resolver: yupResolver(addAccountFormSchema),
};
// ---Secure Document Upload ------------------------------
const SecureDocumentUploadFormSchema = Yup.object().shape({
  category: Yup.string().required("Category is mandatory"),
});
export const SecureDocumentUploadFormOptions = {
  resolver: yupResolver(SecureDocumentUploadFormSchema),
};
export const borrowerFormSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      user: Yup.string()
        .email("Invalid email format")
        .required("Email is mandatory"),
      password: Yup.string().required("Password is mandatory"),
      enrollment_number: Yup.string().required(
        "Enrollment Number is mandatory"
      ),
      confirm_password: Yup.string()
        .required("confirm Password is mandatory")
        .oneOf([Yup.ref("password")], "Passwords does not match"),
    })
  ),
};
// const phoneRegExp =
//   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const phoneRegExp = /\(\d{3}\) \d{3}-\d{4}/;

const passwordRegExp =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&\-])[A-Za-z\d@$!%*?&\-]{8,16}$/;

export const updatedRegisterFormSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      Email: Yup.string()
        .email("Invalid email format")
        .required("Email is mandatory"),
      firstName: Yup.string().required("First Name is mandatory"),
      lastName: Yup.string().required("Last Name is mandatory"),
      Password: Yup.string().required("Password is mandatory"),
      // .matches(
      //   passwordRegExp,
      //   "Password must be 8-16 characters long, include at least one uppercase letter, one lowercase letter, one number, and one special character."
      // )
      confirm_password: Yup.string().required("Confirm password is mandatory"),
      // Password: Yup.string().required("Password is mandatory"),
      Mobile: Yup.string()
        .required("Mobile is mandatory")
        .matches(phoneRegExp, "Mobile is not valid"),
      // registrationCode: Yup.string().required("Registration Code is mandatory"),
    })
  ),
};

const LenderACHInformationFormSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  salutation: Yup.string().required("Salutation is required"),
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  middleInitial: Yup.string().required("Middle initial is required"),
  street: Yup.string().required("Street is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  zipCode: Yup.string().required("Zip code is required"),
  email: Yup.string()
    .email("Email must be valid")
    .required("Email is required"),
  homePhone: Yup.string().required("Home phone is required"),
  workPhone: Yup.string().required("Work phone is required"),
  mobilePhone: Yup.string().required("Mobile phone is required"),
  faxNumber: Yup.string().required("Fax number is required"),
});

export const LenderACHInformationFormOptions = {
  resolver: yupResolver(LenderACHInformationFormSchema),
};

const routingNumRegex = /^\d{9}$/;
const ChequePaymentFormSchema = Yup.object().shape({
  bankAccountName: Yup.string().required("Bank account name is required"),
  address: Yup.string().required("Address is required"),
  cityStateZip: Yup.string().required("City, State, Zip is required"),
  payTo: Yup.string().required("Pay to is required"),
  amount: Yup.string().required("Amount is required"),
  routingNumber: Yup.string()
    .required("Routing number is required")
    .matches(routingNumRegex, "Routing number must be 9 digits"),
  accountNumber: Yup.string().required("Account number is required"),
  verifyAccountNumber: Yup.string().required(
    "Account number verification is required"
  ),
  memo: Yup.string().max(45, "Memo must not exceed 45 characters"),
  // selectedDate: Yup.string().required("Check Date is required"),
});

const NewChequePaymentFormSchema = Yup.object().shape({
  bankAccountName: Yup.string().required("Bank account name is required"),
  address: Yup.string().required("Payee’s Address Line 1 is required"),
  // cityStateZip: Yup.string().required("Payee’s Address Line 2 is required"),
  // payTo: Yup.string().required("Pay to is required"),
  loan_account: Yup.string().required("Loan account is required"),
  amount: Yup.string().required("Amount is required"),
  routingNumber: Yup.string()
    .required("Routing number is required")
    .matches(routingNumRegex, "Routing number must be 9 digits"),
  accountNumber: Yup.string().required("Account number is required"),
  // verifyAccountNumber: Yup.string().required(
  //   "Account number verification is required"
  // ),
  memo: Yup.string().max(45, "Memo must not exceed 45 characters"),
  // selectedDate: Yup.string().required("Check Date is required"),
});

const OneTimeACHPaymentFormSchema = Yup.object().shape({
  bankAccountName: Yup.string().required("Bank account name is required"),
  address: Yup.string().required("Payee’s Address Line 1 is required"),
  // cityStateZip: Yup.string().required("Payee’s Address Line 2 is required"),
  // payTo: Yup.string().required("Pay to is required"),
  loan_account: Yup.string().required("Loan account is required"),
  amount: Yup.string().required("Amount is required"),
  routingNumber: Yup.string()
    .required("Routing number is required")
    .matches(routingNumRegex, "Routing number must be 9 digits"),
  accountNumber: Yup.string().required("Account number is required"),
  // verifyAccountNumber: Yup.string().required(
  //   "Account number verification is required"
  // ),
  memo: Yup.string()
    .required("Comments/Instructions is required")
    .max(45, "Comments/Instructions must not exceed 45 characters"),
  selectedDate: Yup.string().required("Check Date is required"),
});

export const ChequePaymentFormSchemaOptions = {
  resolver: yupResolver(ChequePaymentFormSchema),
};

export const AchPaymentSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      bankAccountName: Yup.string().required(
        "Name on Bank Account is mandatory"
      ),
      routingNumber: Yup.string().required("Routing Number is mandatory"),
      accountNumber: Yup.string().required("Account Number is mandatory"),
      verifyAccountNumber: Yup.string().required("Account Type is mandatory"),
      authorization: Yup.boolean().oneOf([true], "Authorization must be true"),
      selectedReport: Yup.string().required("Report is mandatory"),
      achDebitAmount: Yup.number()
        .required("Amount is mandatory")
        .positive("Amount must be a positive number")
        .max(500000, "** The debit amount must not be more than $500000"),
      selectedPaymentDay: Yup.string().required(
        "Select Payment Day is mandatory"
      ),
      scheduledPaymentStatus: Yup.string().required(
        "Scheduled Payment Status is mandatory"
      ),
      selectedDate: Yup.string().required(
        "Scheduled Payment Date is mandatory"
      ),
    })
  ),
};

export const NewChequePaymentFormSchemaOptions = {
  resolver: yupResolver(NewChequePaymentFormSchema),
};

export const OneTimeACHPaymentFormSchemaOptions = {
  resolver: yupResolver(OneTimeACHPaymentFormSchema),
};

export const AuthenticationSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      email: Yup.string().required("Email is required"),
      password: Yup.string().required("Password is required"),
    })
  ),
};

export const updateACHFormSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      Street: Yup.string().required("Street is required"),
      City: Yup.string().required("City is required"),
      State: Yup.string().required("State is required"),
      ZipCode: Yup.string().required("Zipcode is required"),
      EmailAddress: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // Custom regex for email
          "Invalid email format" // Custom error message
        ),
      PhoneCell: Yup.string().required("Mobile number is required"),
      TINType: Yup.string().required("TINType is required"),
      unmaskedTIN: Yup.mixed(),
      TIN: Yup.string()
        .required("TIN is required")
        .test("custom-tin-validation", "TIN is not valid", function (value) {
          const { TINType, unmaskedTIN } = this.parent;

          // If TIN is empty, skip the custom validation and let the required validation handle it
          if (!value) {
            return true;
          }

          // Validate based on TINType if TIN is provided
          if (TINType && unmaskedTIN) {
            if (TINType[0] === "0" && !/^\d{9}$/.test(unmaskedTIN)) {
              return false; // unmaskedTIN must match 9 digits
            }
            if (
              TINType[0] === "2" &&
              !/^\d{3}-\d{2}-\d{4}$/.test(unmaskedTIN)
            ) {
              return false; // unmaskedTIN must match XXX-XX-XXXX
            }
            if (TINType[0] === "3" && !/^\d{2}-\d{7}$/.test(unmaskedTIN)) {
              return false; // unmaskedTIN must match XX-XXXXXXX
            }
          }

          return true;
        }),
      ACH_BankName: Yup.string()
        .required("Bank Name is required")
        .max(100, "Bank Name cannot exceed 100 characters"),

      ACH_BankAddress: Yup.string()
        .required("Bank Address is required")
        .max(200, "Bank Address cannot exceed 200 characters"),

      ACH_RoutingNumber: Yup.string()
        .required("Routing Number is required")
        .matches(/^\d{9}$/, "Routing Number must be exactly 9 digits"),

      ACH_AccountNumber: Yup.string()
        .required("Account Number is required")
        .min(4, "Account Number must be at least 4 characters")
        .max(17, "Account Number cannot exceed 17 characters"),

      ACH_IndividualId: Yup.string()
        .required("Individual Id is required")
        .max(50, "Individual Id cannot exceed 50 characters"),

      ACH_IndividualName: Yup.string()
        .required("Individual Name is required")
        .max(100, "Individual Name cannot exceed 100 characters"),

      ACH_AccountType: Yup.number()
        .required("Account Type is required")
        .oneOf([0, 1, 2], "Invalid Account Type selection"),

      ACH_ServiceStatus: Yup.number()
        .required("Service Status is required")
        .oneOf([0, 1, 2, 3], "Invalid Service Status selection"),
    })
  ),
};

export const AddChargesSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      ChargeType: Yup.string().required("Charge Type is required"),
      Charge: Yup.string().required("Charge is required"),
      Amount: Yup.string().required("Amount is required"),
    })
  ),
};

export const AddFeesSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      Fee: Yup.string().required("Fee is required"),
      FeeAmount: Yup.string().required("Fee Amount is required"),
    })
  ),
};

export const AddRecipientSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      // PayoffId: Yup.string().required("Payoff Id is required"),
      ReceiverType: Yup.string().required("Receiver Type is required"),

      Loanrecid: Yup.string().required("Loanrecid is required"),
      Ownerredid: Yup.string().required("Ownerredid is required"),
      RecipientName: Yup.string().required("Recipient Name is required"),
      RecipientEmail: Yup.string().required("Recipient Email is required"),
    })
  ),
};

export const createUserSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      firstName: Yup.string().required("First name is required"),
      mobile: Yup.string().required("Phone Number is required"),
      email: Yup.string().required("Email is required"),
      status: Yup.string().required("Status is required"),
      account: Yup.array()
        .of(
          Yup.object().shape({
            label: Yup.string().required(),
            value: Yup.string().required(),
          })
        )
        .min(1, "Account(s) required!")
        .required("Account(s) required!"),
      assignedRole: Yup.string().required("Role is required"),
    })
  ),
};

const roleCreateUserSchema = Yup.object().shape({
  roleName: Yup.string().required("Role name is required!"),
  roleType: Yup.string().required("Role Type is required!"),
  isActive: Yup.string().required("Required field!"),
  roleDescription: Yup.string().required("Role description is required!"),
});
export const roleCreateUserValidations = {
  resolver: yupResolver(roleCreateUserSchema),
};

export const addPaymentAccountSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      BENEFICIARY_NAME: Yup.string().required(
        "Name on Bank Account is mandatory"
      ),
      // bankName: Yup.string().required("Bank name is mandatory"),
      NICK_NAME: Yup.string().required("Account nickname is required"),
      ACCOUNT_TYPE: Yup.string().required("Account type is required"),
      BANK_ADDRESS: Yup.string().required("Your street address as on your Bank Account is required"),
      CITY: Yup.string().required("City is required"),
      STATE: Yup.string().required("State is required"),
      ZIPCODE: Yup.string().required("Zipcode is required"),
      ROUTING_NUMBER: Yup.string()
        .required("Routing Number is required")
        .matches(routingNumRegex, "Routing number must be 9 digits"),
      ACCOUNT_NUMBER: Yup.string().required("Account Number is required"),
      verifyAccountNumber: Yup.string()
        .required("Verify account number is required")
        .oneOf([Yup.ref("ACCOUNT_NUMBER")], "Account numbers must match"),
    }),
  ),
};

export const updatePaymentAccountSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      BENEFICIARY_NAME: Yup.string().required(
        "Name of Bank Account is mandatory",
      ),
      ACH_BANKNAME: Yup.string().required("Bank name is required"),
      NICK_NAME: Yup.string().required("Account nickname is required"),
      ACCOUNT_TYPE: Yup.string().required("Account type is required"),
      BANK_ADDRESS: Yup.string().required("Bank Address is required"),
      // CITY: Yup.string().required("City is required"),
      // STATE: Yup.string().required("State is required"),
      // ZIPCODE: Yup.string().required("Zipcode is required"),
      ROUTING_NUMBER: Yup.string()
        .required("Routing Number is required")
        .matches(routingNumRegex, "Routing number must be 9 digits"),
      ACCOUNT_NUMBER: Yup.string().required("Account Number is required"),
      verifyAccountNumber: Yup.string()
        .required("Verify account number is required")
        .oneOf([Yup.ref("ACCOUNT_NUMBER")], "Account numbers must match"),
    }),
  ),
};

export const IneterestCalculatorSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      balance: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value
        )
        .typeError("Balance must be a valid number")
        .required("Balance Amount is required")
        .positive("Amount must be a positive number")
        .min(1, "Amount must be greater than 0"),
      startDate: Yup.string().required("Start Date is required"),
      annualRatePercent: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value
        )
        .typeError("Rate must be a valid number")
        .required(" Rate is required"),
      termYears: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value
        )
        .typeError("Term in years must be a valid number")
        .required("Term in years is required"),
      yearBasis: Yup.string().required("Daily Rate selection is required"),
      dayCountBasis: Yup.string().required(
        "Days Between Date selection is required"
      ),
    })
  ),
};

export const profileDetailsSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      first_name: Yup.string().required("First Name is required"),
      last_name: Yup.string().required("Last Name is required"),
      mobile: Yup.string().required("Mobile number is required"),
    })
  ),
};

export const taxFormArr = {
  resolver: yupResolver(
    Yup.object()
      .shape({
        sortName: Yup.string().required("Account name is required!"),
        form_SSN: Yup.string()
          .transform((value) => (value === "" ? null : value))
          .nullable()
          .matches(/^\d{3}-\d{2}-\d{4}$/, "SSN must be 9 digits")
          .notRequired(),

        form_EIN: Yup.string()
          .transform((value) => (value === "" ? null : value))
          .nullable()
          .matches(/^\d{2}-\d{7}$/, "EIN must be 9 digits")
          .notRequired(),
      })
      .test(
        "one-of-required",
        "Either SSN or EIN is required",
        function (value) {
          return !!(value.form_SSN || value.form_EIN);
        }
      )
  ),
};

export const achInfoFormSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      bankName: Yup.string().required("Bank Account name is required!"),
      routingNumber: Yup.string()
        .required("Routing number is required")
        .matches(routingNumRegex, "Routing number must be 9 digits"),
      accountNumber: Yup.string().required("Account number is required"),
      debitAmount: Yup.number()
        .transform((value, originalValue) =>
          String(originalValue).trim() === "" ? null : value
        )
        .nullable()
        .typeError("Amount must be a valid number")
        .required("Amount is mandatory")
        .positive("Amount must be a positive number")
        .max(500000, "** The debit amount must not be more than $500000"),
    })
  ),
};

export const insuranceExpiryFormSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      loan_number: Yup.string().required("Loan number is required!"),
      attachment: Yup.mixed().required("File is required"),
    })
  ),
};

export const surveyFormSchema = {
  resolver: yupResolver(
    Yup.object().shape({
      rating: Yup.string().required("Rating is required!"),
      resolutionQuality: Yup.string().required(
        "Resolution quality is required!"
      ),
      email: Yup.string().required("Email is required!"),
    })
  ),
};

export const thirdPartyPayoffSchema = (isValidAccount) => {
  return Yup.object().shape({
    requestor_name: Yup.string().required("Requestor name is required"),
    requestor_type: Yup.string().required("Requestor type is required"),
    cema: Yup.string().required("This field is required!"),
    // requestor_address: Yup.string().required("Lender address is required"),
    // lender_signature: Yup.string(),
    // lender_title: Yup.string().required("Title is required"),
    phone_number: Yup.string(),

    // 🔽 Make property fields optional individually
    borrower_email: Yup.string(),
    remarks: Yup.string(),
    property_street: Yup.string().nullable(),
    property_city: Yup.string().nullable(),
    property_state: Yup.string().nullable(),
    property_zip: Yup.string().nullable(),

    account_name: Yup.string(),
    account_number: Yup.string().nullable(),

    applicant_name: Yup.string(),
    payoff_good_through_date: Yup.string().required("Payoff Good Through Date is required"),
    loan_property: Yup.string(),
    borrower_sign_available: Yup.boolean(),

    borrower_signature: Yup.mixed().when("borrower_sign_available", {
      is: true,
      then: (schema) =>
        schema.required("Please upload borrower's authorization"),
    }),
  });
};